<template lang="pug">
div.home-collections(
    v-observe-visibility="observeVisibilityOptions")

    segment(
        v-if="items.length"
        v-bind:title="$t('navigation.collections')")

        template(#display-options="")
            div.display-option.show-all(
                v-if="isIntersectionVisible")
                router-link(
                    v-bind:to="getLocalizedSearchRoute('Collections')")
                    icon-plus-circle-outline(title='')
                    span.label {{ $t('common.showAll') }}

        div.collection-cards.is-ancestor
            slick-slides(
                v-if="isIntersectionVisible"
                v-bind:options="slickOptions"
                v-bind:items="items")
                template(#slide-card="slotScope")
                    collection-card.collection-card(
                        v-bind:item="slotScope.item"
                        v-bind:resolution="{x: '100vw'}"
                        v-bind:image-as-background="true"
                        v-bind:social="false"
                        v-bind:header="true"
                        v-bind:link-to="true"
                        v-bind:contents="false")

        div.explore(
            v-if="ready && isIntersectionVisible")
            router-link.btn.black(
                v-bind:to="getLocalizedSearchRoute('Collections')")
                span.label {{ $t('navigation.searchCollections') }}


</template>

<script>
import HeroMixin from '@/components/Home/HeroMixin.js';

export default {
    name: 'home-collections',

    mixins: [ HeroMixin ],

    data: function () {
        return {
            slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 3,
                rows: 3,
                arrows: false,
                dots: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 1500,
                autoplay: false,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            rows: 2
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            }
        };
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

.home-collections {
    background-image: linear-gradient(to top, $light-gray);
    .slick-slide {
        display: inline-block;
        float: none;
        vertical-align: top;
        .card-image .card-link,
        .card-image figure {
            min-height: 280px;
            @media screen and (max-width: $breakpoint-tablet - 1) {
                min-height: 400px;
            }
            @media screen and (min-width: $breakpoint-widescreen) {
                min-height: 550px;
            }
        }
        .card .card-header .card-header-title h1, .card .card-header .card-header-title h2 {
            @include dowrap;
        }
    }
    .explore {
        display: flex;
        justify-items: center;
        .btn {
            margin: 2rem auto;
            padding-top: 4px;
        }
    }
}
</style>
